import { getBackendBoolean } from '@Sage/ssm-utils/backendScalars';

export function getShowSalesOrderFooterAmounts(userData) {
    return (
        userData?.showSalesOrderFooterAmounts == null ||
        getBackendBoolean(userData.showSalesOrderFooterAmounts)
    );
}
